<icc-list 
    (select)="selectVariant($event)"
    [selected]="(selectedVariant$ | async)?.id"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    [items]='variants'>
</icc-list>